import { viperApi, clinicalApiPath } from '@/services/viper-api'
import * as qs from 'qs'

export const globalSearchService = {
  basePath: organizationId => `${clinicalApiPath}/organizations/${organizationId}/global-search`,

  get(organizationId, params) {
    return viperApi.get(this.basePath(organizationId), {
      params,
      paramsSerializer: function(params) {
        return qs.stringify(params, {})
      }
    })
  }
}
